<script>
import ButtonAll from '../UI/Button/ButtonAll.vue'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'

export default {
  components: { FormCreator, ModalDialog, ButtonAll },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    id: { type: Number, required: false, default: null },
    financeId: { type: Number, required: false, default: null },
    entityId: { type: Number, required: true },
    signerId: { type: String, required: true },
    allowEditDirector: { type: Boolean, required: false, default: false },
  },

  data: () => ({
    director: {},
    def: {},
    loadField: false,
    loadForm: false,
    params: {},
    sending: false,
    addingDirector: false,
    method: 'post',
    formData: null,
    loading: {
      add: false,
      edit: false,
    },
  }),

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    globalBuild({ loading, build, object, def }) {
      this.loadField = build

      this.def = def
      this.director = object

      if (!loading) {
        this.loading['add'] = false
        this.loading['edit'] = false
      }

      this.$emit('is-loading', loading)
      if (build) {
        this.openModal()
      }
    },
    isSending(bool) {
      this.sending = bool
    },
    showForm(context = 'post') {
      this.loading[context === 'post' ? 'add' : 'edit'] = true
      this.method = context
      this.params = { financeId: this.financeId, entityId: this.entityId }
      if (this.id && context === 'patch') {
        this.params['id'] = this.id
      } else if ($(this.signerId).val() !== null && $(this.signerId).val() !== '' && context == 'patch') {
        this.id = $(this.signerId).val()
        this.params['id'] = $(this.signerId).val()
      }
      this.loadForm = true
    },
    openModal() {
      this.$refs['directorModal'].open()
      if (this.id !== null) {
        this.$refs.modifyUser.sending = false
      }
      this.$refs.addUser.sending = false
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.addingDirector = false
      this.$refs['directorModal'].close(false)
    },
    objectReturn({ object, context }) {
      if (object) {
        switch (context) {
          case 'post':
            var newOption = new Option(object.name, object.id, true, true)
            $(this.signerId).append(newOption).trigger('change.select2')
            this.$emit('addselect', { data: object, value: object.id })
            break
          case 'patch':
            $(this.signerId + ' option[value="' + $(this.signerId).val() + '"]').text(object.name)
            $(this.signerId).select2({ width: '100%' }).trigger('change.select2')
            break
          default:
        }
        this.closeModal()
      }
    },
    validate() {
      this.$refs.myformdirector.methods(this.method)
      this.addingDirector = true
    },
  },
}
</script>
<template>
  <div id="page-director">
    <div class="btn-group" v-if="allowEditDirector || hasRole('ROLE_ADD_MODIFY_DIRECTOR')">
      <ButtonAll
        v-if="id !== null"
        ref="modifyUser"
        :loading="loading['edit']"
        margin="no"
        type="add"
        size="large"
        icon="modify"
        style="border-right: 1px solid !important"
        @click="showForm('patch')"
        name="directorUpdate"
      />
      <ButtonAll
        ref="addUser"
        :loading="loading['add']"
        margin="no"
        type="add"
        size="large"
        icon="add"
        style="border-left: 1px solid !important"
        @click="showForm('post')"
        name="directorCreate"
      />
    </div>
    <ModalDialog
      id="director"
      ref="directorModal"
      id-modal-page="page-director"
      :title="$t('director.modal.title')"
      :multiple="true"
      class-modal-dialog="modal-lg"
      @icon-close="closeModal"
      e2e-modal="director"
    >
      <template #body>
        <FormCreator
          @update-data="updateData"
          v-if="loadForm"
          :id="id"
          ref="myformdirector"
          endpoint="directors"
          :params="params"
          :send-params="true"
          :config-def="def"
          class-to-add="d-none"
          :in-modal="true"
          @global-build="globalBuild"
          @object-return="objectReturn"
          @is-sending="isSending"
        ></FormCreator>
        <field-creator
          :form-data="formData"
          v-if="loadField"
          name="firstname"
          form-ref="myformdirector"
          domain="director"
          :label-top="true"
        ></field-creator>
        <field-creator
          :form-data="formData"
          v-if="loadField"
          name="lastname"
          form-ref="myformdirector"
          domain="director"
          :label-top="true"
        ></field-creator>
        <field-creator
          :form-data="formData"
          v-if="loadField"
          name="dateBirthDirector"
          form-ref="myformdirector"
          domain="director"
          :label-top="true"
        ></field-creator>
      </template>
      <template #footer>
        <ButtonAll margin="no" type="information" @click="closeModal" label="button.cancel" name="close"></ButtonAll>
        <ButtonAll
          margin="no"
          type="validation"
          :loading="sending"
          @click="validate"
          label="button.validate"
          name="directorValidate"
        ></ButtonAll>
      </template>
    </ModalDialog>
  </div>
</template>
